<template lang="pug">
  v-navigation-drawer(app v-model.boolean="showAppDrawer" clipped)
    v-layout(column )
      v-list
        v-list-item(v-if="dashboard" to="/dashboard" exact)
          v-list-item-action
            v-icon fal fa-grip-horizontal
          v-list-item-content  {{ $t('drawerPage.dashboardLabel') }}

        v-list-item(:to="{name: 'Dailymenu', params: this.$route.params.isoWeek + '/' + this.$route.params.date}" exact v-if="denneMenu && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-utensils
          v-list-item-content  {{ $t('drawerPage.dailymenu') }}

        v-list-item( to="/reservation" v-if="objednavky && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-money-check-alt
          v-list-item-content  {{ $t('drawerPage.reservationLabel') }}

        v-list-item( to="/rating" v-if="rating && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-smile
          v-list-item-content  Hodnotenia objednavok

        v-list-item( to="/boarder-management" exact v-if="boarders && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-user-crown
          v-list-item-content  {{ $t('drawerPage.boarderManagementLabel') }}

        v-list-item( to="/discount" exact v-if="discounts && currentUser && currentUser.staffRoleList[0] && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-percentage
          v-list-item-content {{ $t('discountPage.pageTitle') }}

        v-list-item(v-if="delivery" to="/delivery" exact )
          v-list-item-action
            v-icon fas fa-truck
          v-list-item-content  {{ $t('drawerPage.deliveryLabel') }}

        v-list-item( to="/food-database" exact v-if="foodDatabse && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-burger-soda
          v-list-item-content  {{ $t('drawerPage.foodDatabaseLabel') }}

        v-list-item( to="/calendar" exact v-if="calendar && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-calendar-alt
          v-list-item-content {{ $t('drawerPage.calendarLabel') }}

        v-list-item( to="/billing" exact v-if="billing && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-file-invoice
          v-list-item-content {{ $t('drawerPage.billingPageLabel') }}

        v-list-item( to="/bank-transaction" exact v-if="bankStattements && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fas fa-euro-sign
          v-list-item-content  {{ $t('drawerPage.bankTransferLabel') }}

        v-list-item( to="/debtors" exact v-if="debtors && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fas fa-money-bill
          v-list-item-content {{ $t('drawerPage.debtorsPageLabel') }}

        v-list-item( to="/requests" exact v-if="requests && currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-badge-check
          v-list-item-content Žiadosti

        v-list-item( v-if="smartLinks" to="/smart-links" exact )
          v-list-item-action
            v-icon fal fa-link
          v-list-item-content Smart Linky

        v-list-item(v-if="statistics" to="/statistics")
          v-list-item-action
            v-icon fal fa-chart-line
          v-list-item-content Štatistiky

        v-subheader(v-if="currentUser.staffRoleList[0].role.name !== 'delivery_boy'") {{ $t('drawerPage.settingsLabel') }}

        v-list-item( to='/business' exact v-if="currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-city
          v-list-item-content {{ $t('drawerPage.businessPageLabel') }}

        v-list-item( to='/settings/boarder-group' exact v-if="currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-users-cog
          v-list-item-content {{ $t('drawerPage.boarderGroupLabel') }}

        v-list-item( to="/settings" exact v-if="currentUser.staffRoleList[0].role.name !== 'delivery_boy'")
          v-list-item-action
            v-icon fal fa-cog
          v-list-item-content  {{ $t('drawerPage.systemSettingsLabel') }}


</template>

<script lang="ts">
import Vue from 'vue'
import {APP_DRAWER_STATE, GET_KEY_LIST, USER_LOGGED_IN} from '@/store/getter-types'
import {SET_DRAWER_STATE} from '@/store/action-types'
import {CurrentUser} from "@/model/CurrentUser";
import KeyList from "@/model/KeyList";

interface ComponentData {
  dashboard: boolean,
  denneMenu: boolean,
  objednavky: boolean,
  rating: boolean,
  boarders: boolean,
  discounts: boolean,
  delivery: boolean,
  foodDatabse: boolean,
  calendar: boolean,
  billing: boolean,
  bankStattements: boolean,
  debtors: boolean,
  requests: boolean,
  smartLinks: boolean,
  statistics: boolean,
  defaultValue: boolean,
}

export default Vue.extend({
  name: 'AppDrawer',

  data (): ComponentData {
    return {
      dashboard: false,
      denneMenu: false,
      objednavky: false,
      rating: false,
      boarders: false,
      discounts: false,
      delivery: false,
      foodDatabse: false,
      calendar: false,
      billing: false,
      bankStattements: false,
      debtors: false,
      requests: false,
      smartLinks: false,
      statistics: false,
      defaultValue: true,
    }
  },

  computed: {

    getKeyList (): KeyList[] {
      return this.$store.getters[GET_KEY_LIST]
    },

    stateDrawerChanged (): boolean {
      return this.$store.getters[APP_DRAWER_STATE]
    },

    currentUser(): CurrentUser {

      return this.$store.getters[USER_LOGGED_IN]

    },

    showAppDrawer: {
      get (): boolean {
        return this.$store.getters[APP_DRAWER_STATE]
      },

      set (newVal: boolean): void {
        this.$store.dispatch(SET_DRAWER_STATE, newVal)
      }
    }
  },
  watch: {
    getKeyList(newVal: KeyList[]): void {
      if(newVal){
        this.setDrawerMenu()
      }
    },

    stateDrawerChanged (newVal: any): void {
    }
  },

  methods: {
    isStructureKey(): any {
      let isKey: boolean = false
      if(this.getKeyList) {
        this.getKeyList.forEach((item: any) => {
          if (item.key === 'tenant.cp_main_menu_structure') {
            isKey = false
          } else {
            isKey = true
          }
        })
      }
      return isKey
    },

    setDrawerMenu() {
      if(this.getKeyList) {
        this.getKeyList.forEach((item: any) => {
          if(item.key === 'tenant.cp_main_menu_structure' && item.value !== '[]') {
            if(item.value.includes('dashboard')) {
              this.dashboard = true
            } else {
              this.dashboard = false
            }
            if(item.value.includes('daily_menu')) {
              this.denneMenu = true
            } else {
              this.denneMenu = false
            }
            if(item.value.includes('offer_reservations_lc')) {
              this.objednavky = true
            } else {
              this.objednavky = false
            }
            if(item.value.includes('offer_reservation_rating')) {
              this.rating = true
            } else {
              this.rating = false
            }
            if(item.value.includes('boarders')) {
              this.boarders = true
            } else {
              this.boarders = false
            }
            if(item.value.includes('discounts')) {
              this.discounts = true
            } else {
              this.discounts = false
            }
            if(item.value.includes('delivery')) {
              this.delivery = true
            } else {
              this.delivery = false
            }
            if(item.value.includes('food_database')) {
              this.foodDatabse = true
            } else {
              this.foodDatabse = false
            }
            if(item.value.includes('calendar')) {
              this.calendar = true
            } else {
              this.calendar = false
            }
            if(item.value.includes('billing')) {
              this.billing = true
            } else {
              this.billing = false
            }
            if(item.value.includes('bank_statements')) {
              this.bankStattements = true
            } else {
              this.bankStattements = false
            }
            if(item.value.includes('debtors')) {
              this.debtors = true
            } else {
              this.debtors = false
            }
            if(item.value.includes('requests')) {
              this.requests = true
            } else {
              this.requests = false
            }
            if(item.value.includes('smart_links')) {
              this.smartLinks = true
            } else {
              this.smartLinks = false
            }
            if(item.value.includes('stats')) {
              this.statistics = true
            } else {
              this.statistics = false
            }

          }
          if(item.key !== 'tenant.cp_main_menu_structure') {
              this.dashboard = true
              this.denneMenu = true
              this.objednavky = true
              this.rating = true
              this.boarders = true
              this.discounts = true
              this.delivery = true
              this.foodDatabse = true
              this.calendar = true
              this.billing = true
              this.bankStattements = true
              this.debtors = true
              this.requests = true
              this.smartLinks = true
              this.statistics = true
          }
        })
      }
    }
  },

  mounted() {
  }


})
</script>

<style lang="stylus" scoped>

</style>
